// extracted by css-extract-rspack-plugin
module.exports =  {"autoClose":"NF2re","autoCloseTimer":"wHV6X","grayBorder":"_lZUu","timer":"BMuIR","circularChart":"BJXIy","circle":"ZlTWb","spin":"g_4Lc","closeBtn":"cKpzn","hide":"zNC8l"};